document.addEventListener("DOMContentLoaded", () => {
  // タイストアのみLINE再入荷通知ボタンを一旦非表示
  var domain = window.location.hostname;
  var domainThaiFlag = false;
  if(domain == "th.bonaventura.shop"){
    domainThaiFlag = true;
  }

  // タイストアだったらwazzup LINE再入荷ボタン削除
  var wazzupButton = document.getElementById('wazzupButton');
  if(domainThaiFlag){
    wazzupButton.style.display = 'none';
  }

  // セッションストレージから保存された値を取得
  const selectedColor = sessionStorage.getItem("selectedColor");
  const inputText = sessionStorage.getItem("combinedLetters");
  const kokuinBtnText = document.querySelector("#openDrawerText");
  const orderLetters = document.querySelector('#LettersForCustomize');
  const colorInput = document.querySelector('#ColorForCustomize');
  const arrow = document.querySelector(".customize--arrow");
  if (
    selectedColor !== "" &&
    selectedColor !== null &&
    inputText !== "" &&
    inputText !== null
  ) {
    kokuinBtnText.innerHTML = `入力文字：${inputText}<span class="selectColorWrap">選択色：<span class="selectColor" data-value="${selectedColor}" style="background-color: ${
      selectedColor === "ゴールド" ? "#e6b422" : "#c0c0c0"
    };"></span></span>`;
    arrow.style.display = "none";
    orderLetters.value = inputText;
    colorInput.value = selectedColor;
  }
});
